import { createApiSlice } from '@/shared/features/query/config/query.build';
import type { MenuItem } from '../../domain/models/MenuItem';
import type { DesktopNavItem } from '../../domain/models/DesktopNavItem';
import type { MenuResponseDTO } from '../dto/menu.dto';
import { adaptMenuResponseToHamburgerAndDesktop } from '../mappers/menu.mapper';
import type { ReduxQueryClient } from '@/shared/features/query/domain/interfaces/QueryClient';

export interface MenuApiResponse {
  hamburger: MenuItem[];
  desktop: DesktopNavItem[];
  desktopRightAlignedTrailingMenuCount?: number;
}

const menuApiSlice = createApiSlice({
  clientId: 'menuApi',
  tagTypes: ['Menu'],
  endpoints: {
    getMenu: {
      url: '/menu/hamburger',
      method: 'GET',
      transformResponse: (response: unknown): MenuApiResponse => {
        const dto = (typeof response === 'object' && response !== null ? response : {}) as MenuResponseDTO;
        return adaptMenuResponseToHamburgerAndDesktop(dto);
      },
      providesTags: ['Menu'],
    },
  },
});

// Export the query client for programmatic access (used by repository adapters)
export const menuApi = menuApiSlice.queryClient;

// Export hooks for menu (RTK Query-specific, but abstracted)
// These hooks are adapter-specific and may not exist for other adapters
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hooks = menuApiSlice.hooks as any;
export const useGetMenuQuery = hooks?.useGetMenuQuery;
export const useLazyGetMenuQuery = hooks?.useLazyGetMenuQuery;

// Export Redux-specific properties for store configuration (RTK Query only)
// These are only available when using RTK Query adapter
export const menuApiRedux = menuApiSlice.queryClient as ReduxQueryClient;

// Export the API slice instance for use in store configuration
export default menuApiSlice;

